import * as Y from 'yjs';
import { HocuspocusProvider } from '@hocuspocus/provider';
import { storage } from '@shared/lib/storage';

// Mirrors the API base switch in services/api.ts. In production the collab
// websocket rides the existing api.hintword.com TLS cert via nginx /collab.
const COLLAB_BASE = process.env.NODE_ENV === 'development'
  ? 'ws://localhost:9098'
  : 'wss://api.hintword.com/collab';

export interface CollabSession {
  ydoc: Y.Doc;
  provider: HocuspocusProvider;
  destroy: () => void;
}

/** Open a live-editing session for a note (room = note_id, auth = user JWT). */
export function createCollabSession(noteId: string): CollabSession {
  const ydoc = new Y.Doc();
  const provider = new HocuspocusProvider({
    url: COLLAB_BASE,
    name: noteId,
    document: ydoc,
    token: storage.getItem('hintword_token') ?? '',
  });

  let destroyed = false;
  return {
    ydoc,
    provider,
    destroy: () => {
      if (destroyed) return;
      destroyed = true;
      try { provider.destroy(); } catch { /* already closed */ }
      try { ydoc.destroy(); } catch { /* already destroyed */ }
    },
  };
}

// Stable, pleasant caret colors — hash the user id onto a fixed palette so a
// user keeps the same color across sessions and devices.
const CARET_COLORS = [
  '#ea580c', '#0ea5e9', '#16a34a', '#9333ea', '#e11d48',
  '#f59e0b', '#0891b2', '#7c3aed', '#65a30d', '#db2777',
];

export function caretColorFor(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash * 31 + userId.charCodeAt(i)) >>> 0;
  }
  return CARET_COLORS[hash % CARET_COLORS.length];
}
